import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map, take } from 'rxjs/operators';
import axios from 'axios';
@Injectable({ providedIn: 'root' })
export class FeedbackService {
  myAppUrl: any = location.origin + '/';

  private DataPassed = new BehaviorSubject(undefined);
  private InitializeEdit = new BehaviorSubject(undefined);
  Data = this.DataPassed.asObservable();
  ReInitializeEdit = this.InitializeEdit.asObservable();
  public uploadURL = '#SAVEPATH#/#FILENAME#.';

  baseUrl = 'https://entityserver.manikworks.com';
  citizenUrl = 'https://citizen.instaciti.com';

  honoUrl = 'https://bizmgr.dotly.app';
  constructor(public _httpClient: HttpClient) {}

  initializeApp(): any {}

  getToken(header: HttpHeaders) {
    return this._httpClient
      .get(this.baseUrl + '/apptoken', { headers: header })
      .pipe(
        map((value) => value),
        take(1)
      );
  }

  getFeebackFormData(header: HttpHeaders) {
    return this._httpClient
      .post(this.baseUrl + '/bizapp', {}, { headers: header })
      .pipe(
        map((value) => value),
        take(1)
      );
  }
  getWizardHtml(header: HttpHeaders) {
    return this._httpClient
      .post(this.baseUrl + '/fetchwizardhtml', {}, { headers: header })
      .pipe(
        map((value) => value),
        take(1)
      );
  }

  getEcomOrderData(header: HttpHeaders) {
    return this._httpClient
      .post(this.baseUrl + '/storemgr', {}, { headers: header })
      .pipe(
        map((value) => value),
        take(1)
      );
  }

  enquiryHTMLFormApi(header: HttpHeaders) {
    return this._httpClient
      .post(this.baseUrl + '/fetchwizardhtml', {}, { headers: header })
      .pipe(
        map((value) => value),
        take(1)
      );
  }

  saveFeedbackEmoji(data: any, header: HttpHeaders) {
    return this._httpClient
      .post(this.baseUrl + '/apputils', data, { headers: header })
      .pipe(
        map((value) => value),
        take(1)
      );
  }
  saveHonoEmoji(data: any, header: HttpHeaders) {
    return this._httpClient
      .post(this.baseUrl + '/bizapp', data, { headers: header })
      .pipe(
        map((value) => value),
        take(1)
      );
  }

  loginViaMobile(data: any, header: HttpHeaders) {
    return this._httpClient
      .post(this.citizenUrl + '/citizenship', data, { headers: header })
      .pipe(
        map((value) => value),
        take(1)
      );
  }

  loginViaEmail(data: any, header: HttpHeaders) {
    return this._httpClient
      .post(this.citizenUrl + '/citizenship', data, { headers: header })
      .pipe(
        map((value) => value),
        take(1)
      );
  }

  uploadImage(url, formdata: any, config: any) {
    return axios.post(url + '/imageupload', formdata, config).then();
  }

  verifyOtp(header: HttpHeaders) {
    return this._httpClient
      .post(this.citizenUrl + '/citizenship', {}, { headers: header })
      .pipe(
        map((value) => value),
        take(1)
      );
  }

  getProfile(data: any, header: HttpHeaders) {
    return this._httpClient
      .post(this.citizenUrl + '/citizenship', data, { headers: header })
      .pipe(
        map((value) => value),
        take(1)
      );
  }
  isLoggedIn(data: any, headers: HttpHeaders) {
    return this._httpClient
      .post(this.citizenUrl + '/citizenship', data, {
        headers: headers,
      })
      .pipe(
        map((value) => value),
        take(1)
      );
  }
  getFetchProfile(obj: any, header: HttpHeaders) {
    return this._httpClient.post(this.citizenUrl + '/citizenship', {}).pipe(
      map((value) => value),
      take(1)
    );
  }
  addProfile(data: any, config: any) {
    return axios
      .post('https://entityserver.manikworks.com/apputils', data, config)
      .then();
  }
}
